import type { FC } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import type { FlowComponentRenderProps, NotesComponentConfig } from '../types';
import HtmlText from '../components/HtmlText';

/** Inline technician notes for the feedback presentation. The shell owns the glass card. */
const FeedbackTechnicianNotes: FC<FlowComponentRenderProps<NotesComponentConfig>> = ({ config }) => (
  <Stack data-testid="feedback-technician-notes" spacing={1}>
    <HtmlText
      component="div"
      html={config.title ?? 'Service notes'}
      variant="subtitle1"
      sx={{
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        textAlign: 'center',
      }}
    />
    <Box
      sx={{
        border: '1px solid rgba(145, 158, 171, 0.32)',
        borderRadius: '6px',
        p: 1.5,
      }}
    >
      <HtmlText
        component="div"
        html={config.body}
        variant="body2"
        sx={{ color: 'var(--cx-brand-text)', fontSize: 15, lineHeight: '24px' }}
      />
    </Box>
  </Stack>
);

export default FeedbackTechnicianNotes;
